var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCopyWithTitle = function SvgIcnCopyWithTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 9.33398H11.6668C10.3782 9.33398 9.3335 10.3787 9.3335 11.6673V21.0007C9.3335 22.2893 10.3782 23.334 11.6668 23.334H21.0002C22.2888 23.334 23.3335 22.2893 23.3335 21.0007V11.6673C23.3335 10.3787 22.2888 9.33398 21.0002 9.33398Z",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 9.33268V6.99935C18.6665 6.38051 18.4207 5.78702 17.9831 5.34943C17.5455 4.91185 16.952 4.66602 16.3332 4.66602H6.99984C6.381 4.66602 5.78751 4.91185 5.34992 5.34943C4.91234 5.78702 4.6665 6.38051 4.6665 6.99935V16.3327C4.6665 16.9515 4.91234 17.545 5.34992 17.9826C5.78751 18.4202 6.381 18.666 6.99984 18.666H9.33317",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCopyWithTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_copy_with_title.d3c67ea8.svg";
export { ForwardRef as ReactComponent };